<template>
    <div class="border border-grey-200 shadow-md rounded-xl grid grid-cols-2 gap-10 mobile:gap-5 mobile:grid-cols-1 mobile:p-6 bg-gradient-to-r from-white to-grey-100/60 overflow-clip">
        <div class="my-auto px-10 py-14 mobile:p-0">
            <div class="mb-3 font-bold text-balance text-xl tablet:text-xl mobile:text-base">{{noAccessModel.title}}</div>
            <div class="mobile:text-sm text-grey-800" v-html="noAccessModel.description.replace(/\n/g, '<br/>')">
             
            </div>
            <div class="flex space-x-3 mt-5 tablet:mt-6">
                <template v-if="isBlocked">
                    <a href="" class="btn btn-primary" v-on:click.prevent="createReactivationLead">
                        {{translate('contact_me')}}
                    </a>
                    <a href="/order" class="btn btn-ghost"> {{translate('tarieven')}}</a>
                </template>
                <div v-else >
                    <div v-if="!hasAccessToCountry" class="font-medium mt-4 mb-2">
                        {{translate('add_country_to_subscription', translate('internationaal_rapport_country_' + detailStore.country))}}
                    </div>
                    <div>
                        <a :href="primaryLink" class="btn btn-primary" :disabled="isDisabled">
                            {{ detailStore.isLoggedIn
                            ? !hasAccessToCountry ? translate('upgrade_now') :  translate('meer_ontdekken')
                            : translate('probeer_gratis') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center dotted-bg h-full">
           <div v-if="subPage === SubPage.DIRECTORS" class="py-4 mobile:py-0">
               <img v-if="detailStore.isBelgian" :src="'/images-new/accordion/product-information/management.'+language+'.svg'" alt="Directors" class="max-w-96 mx-auto" />
               <img v-else :src="'/images-new/accordion/product-information/management.'+language+'-NL.svg'" alt="Directors" class="max-w-96 mx-auto" />
           </div>
            <div v-else-if="subPage === SubPage.PARTICIPATIONS" class="flex items-center justify-center">
                <img :src="'/images-new/accordion/product-information/ownership.'+language+'.svg'" alt="Ownership" class="max-w-96 mx-auto" />
            </div>
            <div v-else-if="subPage === SubPage.LOCATIONS" class="h-full flex items-center p-6 mobile:py-0 justify-center">
                <img  :src="'/images-new/tools/locations.'+language+'.svg'" alt="Locations" class="rounded-2xl shadow-lg p-4 bg-white max-w-96 mx-auto" />
            </div>
            <div v-else-if="subPage === SubPage.TIMELINE" class="h-full my-auto">
                <img v-if="detailStore.isBelgian" :src="'/images-new/accordion/product-information/timeline.'+language+'.svg'" alt="Timeline" class="max-w-96 mx-auto" />
                <img v-else :src="'/images-new/accordion/product-information/timeline.'+language+'-NL.svg'" alt="Timeline" class="max-w-96 mx-auto" />
            </div>
            <div v-else-if="subPage === SubPage.KYC" class="h-full flex items-center pr-4 justify-center">
                <img  :src="'/images-new/kyc-hero.'+language+'.svg'" alt="Ownership" />
            </div>
            <div v-else-if="subPage === SubPage.FINANCIAL_STATEMENTS" class="text-right relative pr-6 py-6 mobile:py-0">
                <img :src="'/images-new/tools/jaarrekeningen.'+language+'.svg'" class=" w-auto max-w-none h-60 inline-block border border-grey-200 rounded-xl" alt="Jaarrekeningen">
                <img :src="'/images-new/tools/jaarrekeningen-export.'+language+'.svg'" class="animate-bounce absolute bottom-12 left-4 w-32 border border-grey-300 rounded-lg shadow-lg" alt="Jaarrekeningen export">
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {useDetailStore} from '../store';
import {SubPage} from "../types";
import {defineComponent} from 'vue';

interface NoAccessModel {
    title: string;
    description: string;
    upgradeUrl: string;
}

export default defineComponent({
    name: "no-access",
    props:{
        subPage: String as () => SubPage
    },
    data() {
        return {
            detailStore: useDetailStore(),
            SubPage
        }
    },
    computed: {
        hasAccessToCountry(): boolean {
            return this.store.countryPermissions[this.detailStore.country] ?? false  
        },
        language(): string {
            return this.detailStore.language  
        },
        primaryLink(): string {
            return this.detailStore.isLoggedIn 
                ? !this.hasAccessToCountry ? ("/upgrade/ayce?countries=" + this.detailStore.country) : this.noAccessModel.upgradeUrl 
                : "/trial";  
        },
        isDisabled(): boolean {
            return this.detailStore.isTrial && this.subPage === SubPage.KYC;
        },
        isBlocked(): boolean {
            return this.detailStore.isBlocked;
        },
        noAccessModel(): NoAccessModel{
            switch (this.subPage) {
                case SubPage.DIRECTORS:
                    return {
                        title: this.translate('no_access_directors_title'),
                        description: this.translate('no_access_directors_desc'),
                        upgradeUrl: "/upgrade/mandates"
                    }
                case SubPage.PARTICIPATIONS:
                    return {
                        title: this.translate('no_access_participations_title'),
                        description: this.translate('no_access_participations_desc'),
                        upgradeUrl: ""
                    }
                case SubPage.LOCATIONS:
                    return {
                        title: this.translate('no_access_locations_title'),
                        description: this.translate('no_access_locations_desc'),
                        upgradeUrl: ""
                    }
                case SubPage.TIMELINE:
                    return {
                        title: this.translate('no_access_timeline_title'),
                        description: this.translate('no_access_timeline_desc'),
                        upgradeUrl: "/upgrade/timeline"
                    }
                case SubPage.KYC:
                    return {
                        title: this.translate('no_access_kyc_title'),
                        description: this.translate('no_access_kyc_desc'),
                        upgradeUrl: "/upgrade/kyc"
                    }
                case SubPage.FINANCIAL_STATEMENTS:
                    return {
                        title: this.translate('no_access_financial_statements_title'),
                        description: this.translate('no_access_financial_statements_desc'),
                        upgradeUrl: ""
                    }
                default:  
                    return {
                        title: "title___",
                        description: "description___",
                        upgradeUrl: ""
                    }
            }
        }
    }
});
</script>